<!-- Console action feedback 0.1.155; 2026-10-28 18:11:13 CST; parent 44dbda7a05c960e3c79c6c322d676ac5e4982b20. -->
<!-- HotX Console 0.1.109 TRON 游客态。实际修改时间：2026-09-16 13:54:40 CST；精确父基线：cf5594169b784b215a2924abbfc0042baef03cbf。 -->
<template>
  <!-- 2026-09-03: 仅保留 TokenPocket USDT 转账页地址扫码；已删除首页扫码入口及全部相关引导。 -->
  <div class="recharge-page" v-loading="pageLoading">
    <header class="recharge-hero">
      <div class="hero-copy-block">
        <RouterLink to="/points" class="back-link">积分中心 / 充值</RouterLink>
        <h1>TRON 充值</h1>
        <p>支持 USDT-TRC20 与 TRX。链上确认后自动换算积分，1 积分 = 1 美元。</p>
      </div>
      <div class="hero-side">
        <!-- 2026-09-03 CST：跨链入口只负责导航，严禁复用或合并 TRON 与 BSC 的订单、地址及扫描状态。 -->
        <RouterLink to="/bsc-recharge" class="bsc-link">前往 BSC 充值</RouterLink>
        <div class="balance-summary">
          <span>当前积分</span>
          <strong>{{ guestMode ? '--' : amount3(points.summary?.balance) }}</strong>
          <RouterLink to="/points">查看积分流水</RouterLink>
        </div>
      </div>
    </header>

    <el-alert
      v-if="pageError"
      :title="pageError"
      type="error"
      show-icon
      :closable="false"
    />
    <el-alert
      v-else-if="accountDisabled"
      title="当前账号已禁用，不能创建充值订单、绑定地址或提交认领；历史记录仍会保留。"
      type="warning"
      show-icon
      :closable="false"
    />
    <el-alert
      v-else-if="config && !config.rechargeEnabled"
      title="充值服务当前已暂停，已有订单和历史记录仍可查看。"
      type="warning"
      show-icon
      :closable="false"
    />

    <main class="recharge-workspace">
      <section class="surface order-builder">
        <div class="section-heading">
          <div>
            <h2>创建充值订单</h2>
            <p>先选择币种和数量，订单创建后再按页面给出的精确金额付款。</p>
          </div>
          <span class="network-chip">TRON Mainnet</span>
        </div>

        <div v-if="assetOptions.length" class="asset-switcher" aria-label="选择充值币种">
          <button
            v-for="asset in assetOptions"
            :key="asset.assetCode"
            type="button"
            class="asset-option"
            :class="{ active: selectedAsset === asset.assetCode }"
            :disabled="!asset.enabled || actionBlocked"
            @click="selectedAsset = asset.assetCode"
          >
            <span class="asset-symbol">{{ assetSymbol(asset.assetCode) }}</span>
            <span>
              <b>{{ asset.displayName }}</b>
              <small>{{ asset.enabled ? 'TRON 网络' : '暂未开放' }}</small>
            </span>
          </button>
        </div>
        <div v-else-if="!pageLoading" class="inline-empty">
          {{ guestMode ? '当前未登录，登录后可查看可用充值币种并创建订单。' : '暂无可用充值币种，请稍后再试。' }}
        </div>

        <div v-if="selectedAssetOption" class="rate-strip">
          <span>当前结算参考</span>
          <strong v-if="selectedAsset === 'USDT_TRC20'">1 USDT = 1.000 积分</strong>
          <strong v-else-if="selectedAssetOption.usdRate">1 TRX = {{ amount3(selectedAssetOption.usdRate) }} 积分</strong>
          <strong v-else>本周 TRX 价格等待更新</strong>
          <small v-if="selectedAsset === 'TRX' && selectedAssetOption.rateSource">
            来源 {{ selectedAssetOption.rateSource }}，更新时间 {{ dateTime(selectedAssetOption.rateUpdatedAt) }}
          </small>
        </div>

        <el-form label-position="top" class="amount-form" @submit.prevent="handleCreateOrder">
          <el-form-item :label="`充值数量（${selectedSymbol}）`">
            <!-- 2026-09-03 CST: Guide attention only while the amount is empty; focus or input stops the breathing cue. -->
            <el-input
              v-model="amountInput"
              class="recharge-amount-input"
              :class="{ 'is-empty-guided': amountInput.trim().length === 0 }"
              inputmode="decimal"
              maxlength="24"
              placeholder="请输入充值数量"
              :disabled="actionBlocked || !selectedAssetOption?.enabled || orderLimitReached"
              @keyup.enter="handleCreateOrder"
            >
              <template #append>{{ selectedSymbol }}</template>
            </el-input>
          </el-form-item>
          <p class="field-help">
            系统优先分配 0.001 至 0.099 的唯一尾数，容量不足时自动扩展至 0.999；请按订单精确金额付款。
          </p>
          <p v-if="selectedAsset === 'TRX'" class="field-help">
            TRX 按后台每周价格换算，积分最终按链上实际到账数量计算。
          </p>
          <p v-if="selectedAssetOption?.minimumSuggestedAmount" class="minimum-hint">
            建议最低充值 {{ amount3(selectedAssetOption.minimumSuggestedAmount) }} {{ selectedSymbol }}，该数值仅作提示。
          </p>
          <el-button
            type="primary"
            size="large"
            class="create-button"
            :data-amount-ready="Number(amountInput) > 0 ? 'true' : 'false'"
            :loading="creatingOrder"
            :disabled="actionBlocked || !selectedAssetOption?.enabled || orderLimitReached"
            @click="handleCreateOrder"
          >
            {{ orderLimitReached ? `有效订单已达 ${maxActiveOrders} 个` : '生成付款订单' }}
          </el-button>
          <p class="active-order-limit">当前有效订单 {{ activeOrders.length }} / {{ maxActiveOrders }}</p>
        </el-form>

        <div class="safety-note">
          <b>只向订单显示的 TRON 地址转账</b>
          <span>平台仅监测公开收款地址，不保存私钥或助记词，也不会自动转出链上资产。</span>
        </div>
      </section>

      <section class="surface payment-board">
        <div class="section-heading">
          <div>
            <h2>当前付款订单</h2>
            <p>页面会自动刷新链上检测与确认状态。</p>
          </div>
          <el-button :loading="refreshingOrder" @click="refreshOrder">刷新状态</el-button>
        </div>

        <template v-if="activeOrder">
          <div v-if="activeOrders.length > 1" class="active-order-switcher">
            <button
              v-for="order in activeOrders"
              :key="order.orderId"
              type="button"
              :class="{ active: order.orderId === activeOrder.orderId }"
              @click="selectActiveOrder(order)"
            >
              {{ assetSymbol(order.assetCode) }} {{ amount3(order.expectedAmount) }}
            </button>
          </div>
          <div class="order-state-row">
            <el-tag :type="statusMeta(activeOrder.status).tag" effect="plain">
              {{ statusMeta(activeOrder.status).label }}
            </el-tag>
            <span v-if="isOpenRechargeOrder(activeOrder.status)" class="countdown">
              {{ activeOrder.paymentPaused ? '倒计时已暂停' : '付款倒计时' }} <b>{{ orderCountdown }}</b>
            </span>
            <span v-else class="order-number">{{ activeOrder.orderId }}</span>
          </div>

          <el-alert
            v-if="activeOrder.paymentPaused"
            title="链上通道暂时异常，订单倒计时已经暂停，请暂勿付款并联系我们。"
            type="error"
            show-icon
            :closable="false"
            class="provider-paused-alert"
          />
          <div v-if="paymentInstructionsVisible" class="payment-core">
            <div
              v-if="qrContent"
              class="qr-shell"
              :aria-label="isUsdtOrder ? 'USDT-TRC20 收款地址二维码' : 'TRX 付款二维码'"
            >
              <span class="qr-step">{{ isUsdtOrder ? '步骤 1 · 进入 USDT 转账页' : '扫码付款' }}</span>
              <div class="qr-frame">
                <QrcodeVue :value="qrContent" :size="isUsdtOrder ? 268 : 210" level="L" render-as="svg" />
              </div>
              <strong v-if="isUsdtOrder">
                {{ usdtQrMode === 'amount' ? 'USDT-TRC20 付款码' : 'USDT 地址码' }}
              </strong>
              <strong v-else>TRX 付款码</strong>
              <small v-if="isUsdtOrder">
                {{ usdtQrMode === 'amount' ? '从 USDT 转账页，自动带入地址和本单精确金额' : '扫码带入地址后，请手动填写本单精确金额' }}
              </small>
              <small v-else>扫码后核对网络为 TRON</small>
            </div>
            <div v-else-if="isUsdtOrder" class="qr-shell" aria-label="USDT 安全二维码不可用">
              <strong>USDT 安全二维码暂不可用</strong>
              <small>请进入钱包的 USDT-TRC20 转账页后复制地址付款</small>
            </div>
            <div class="payment-instructions">
              <div class="amount-block">
                <span class="instruction-label">本单精确付款金额</span>
                <div class="exact-amount">
                  <strong
                    class="payment-amount-tail-focus"
                    :aria-label="amount3(activeOrder.expectedAmount)"
                  >
                    <span class="payment-amount-major" aria-hidden="true">
                      {{ amount3(activeOrder.expectedAmount).slice(0, -3) }}
                    </span>
                    <span class="payment-amount-tail" aria-hidden="true">
                      <span
                        v-for="(digit, index) in amount3(activeOrder.expectedAmount).slice(-3).split('')"
                        :key="`${activeOrder.orderId}-tail-${index}`"
                        class="payment-amount-tail-digit"
                        :class="`payment-amount-tail-digit-${index + 1}`"
                      >{{ digit }}</span>
                      <small class="payment-tail-caption">重点核对后三位</small>
                    </span>
                  </strong>
                  <b>{{ assetSymbol(activeOrder.assetCode) }}</b>
                </div>
                <button class="copy-action" type="button" @click="copyText(activeOrder.expectedAmount, '付款金额')">
                  复制精确金额
                </button>
              </div>
              <div class="exact-match-notice" role="note" aria-label="精确金额到账提示">
                <div class="exact-match-copy">
                  <strong>链上实际到账金额必须与本单金额完全一致</strong>
                  <span class="exact-match-risk-line">
                    到账金额
                    <b class="exact-match-risk-word exact-match-risk-word-1">偏少</b>、
                    <b class="exact-match-risk-word exact-match-risk-word-2">偏多</b>或
                    <b class="exact-match-risk-word exact-match-risk-word-3">尾数不同</b>，积分都不会自动到账。
                  </span>
                </div>
                <span class="recovery-flow" aria-hidden="true"></span>
                <div class="exact-match-actions">
                  <button type="button" @click="openClaimAssistance">前往自动认领</button>
                  <button type="button" @click="showPaymentSupport">联系我们</button>
                </div>
              </div>
              <ol v-if="isUsdtOrder" class="payment-flow" aria-label="USDT 付款步骤">
                <li>
                  <span>1</span>
                  <div><b>进入 USDT 转账页面</b><small>网络选择 TRON（TRC20）</small></div>
                </li>
                <li>
                  <span>2</span>
                  <div>
                    <b>点击扫码并读取地址</b>
                    <small>扫描左侧收款地址码</small>
                  </div>
                </li>
                <li>
                  <span>3</span>
                  <div>
                    <b>填写并核对精确金额</b>
                    <small>付款前再次核对币种与金额</small>
                  </div>
                </li>
              </ol>

              <div class="address-block">
                <span class="instruction-label address-label">统一平台收款地址</span>
                <div class="address-line">
                  <code>{{ activeOrder.receiveAddress }}</code>
                  <button type="button" @click="copyText(activeOrder.receiveAddress || '', '收款地址')">复制</button>
                </div>
              </div>
              <p v-if="!isUsdtOrder">本单币种为 TRX，网络必须选择 TRON。</p>
            </div>
          </div>
          <div v-else-if="!activeOrder.paymentPaused" class="payment-status-only">
            <b>{{ paymentStatusMessage }}</b>
            <span>收款地址和二维码仅在有效付款倒计时内展示。</span>
          </div>

          <el-steps :active="statusMeta(activeOrder.status).step" align-center finish-status="success" class="order-steps">
            <el-step title="等待付款" />
            <el-step title="检测到账" />
            <el-step title="区块确认" />
            <el-step title="积分到账" />
          </el-steps>

          <div class="order-facts">
            <div>
              <span>链上实际到账</span>
              <b>{{ activeOrder.actualAmount ? `${amount3(activeOrder.actualAmount)} ${assetSymbol(activeOrder.assetCode)}` : '等待检测' }}</b>
            </div>
            <div>
              <span>实际入账积分</span>
              <b>{{ activeOrder.creditedPoints ? amount3(activeOrder.creditedPoints) : '等待入账' }}</b>
            </div>
            <div>
              <span>确认进度</span>
              <b>{{ confirmationText(activeOrder) }}</b>
            </div>
          </div>

          <el-alert
            v-if="activeOrder.latePayment"
            title="该笔款项在订单窗口结束后到达，系统已按真实链上交易继续核验。"
            type="warning"
            show-icon
            :closable="false"
          />
          <p class="actual-rule">最终以链上实际到账为准；同一链上交易只允许入账一次。</p>

          <div class="order-actions">
            <a
              v-if="transactionUrl(activeOrder.txid)"
              :href="transactionUrl(activeOrder.txid)"
              target="_blank"
              rel="noopener noreferrer"
            >
              在 TRONSCAN 查看交易
            </a>
            <el-button
              v-if="canCancelRechargeOrder(activeOrder.status)"
              text
              :loading="cancellingOrder"
              @click="cancelActiveOrder"
            >
              取消订单
            </el-button>
          </div>
        </template>

        <div v-else class="payment-empty">
          <div class="empty-mark">TRON</div>
          <h3>暂无待付款订单</h3>
          <p>创建有效订单后，这里才会显示二维码、统一收款地址、精确金额和实时链上状态。</p>
        </div>
      </section>
    </main>

    <section class="surface records-surface">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="充值记录" name="orders">
          <div class="tab-toolbar">
            <div>
              <h2>充值记录</h2>
              <p>订单状态来自链上扫描与积分账本结果，不由页面推断成功。</p>
            </div>
            <div class="filters">
              <el-select v-model="historyAsset" clearable placeholder="全部币种" @change="resetHistory">
                <el-option label="USDT-TRC20" value="USDT_TRC20" />
                <el-option label="TRX" value="TRX" />
              </el-select>
              <el-select v-model="historyStatus" clearable placeholder="全部状态" @change="resetHistory">
                <el-option label="等待付款" value="WAITING_PAYMENT" />
                <el-option label="确认中" value="CONFIRMING" />
                <el-option label="已入账" value="SUCCESS" />
                <el-option label="人工复核" value="MANUAL_REVIEW" />
                <el-option label="已过期" value="EXPIRED" />
              </el-select>
            </div>
          </div>
          <div class="table-scroll">
            <el-table :data="orders" v-loading="historyLoading" empty-text="暂无充值记录">
              <el-table-column prop="createdAt" label="创建时间" min-width="168">
                <template #default="scope">{{ dateTime(scope.row.createdAt) }}</template>
              </el-table-column>
              <el-table-column prop="orderId" label="订单号" min-width="190" />
              <el-table-column label="币种" width="92">
                <template #default="scope">{{ assetSymbol(scope.row.assetCode) }}</template>
              </el-table-column>
              <el-table-column label="应付 / 实到" min-width="170">
                <template #default="scope">
                  {{ amount3(scope.row.expectedAmount) }} / {{ scope.row.actualAmount ? amount3(scope.row.actualAmount) : '-' }}
                </template>
              </el-table-column>
              <el-table-column label="到账积分" width="118" align="right">
                <template #default="scope">{{ scope.row.creditedPoints ? amount3(scope.row.creditedPoints) : '-' }}</template>
              </el-table-column>
              <el-table-column label="状态" width="122">
                <template #default="scope">
                  <el-tag :type="statusMeta(scope.row.status).tag" effect="plain">{{ statusMeta(scope.row.status).label }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="88" fixed="right">
                <template #default="scope">
                  <el-button link type="primary" @click="openOrderDetail(scope.row.orderId)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            v-if="historyTotal > historyPageSize"
            v-model:current-page="historyPage"
            :page-size="historyPageSize"
            :total="historyTotal"
            layout="prev, pager, next"
            @current-change="loadOrders"
          />
        </el-tab-pane>

        <el-tab-pane label="付款地址" name="addresses">
          <div class="tab-toolbar">
            <div>
              <h2>常用付款地址</h2>
              <p><b>绑定完全可选。</b>不绑定地址也可以创建订单、正常充值和自动到账。</p>
            </div>
            <span>{{ bindings.length }} / {{ config?.maxBoundAddresses || 10 }}</span>
          </div>
          <div v-if="config?.addressBindingEnabled" class="address-form">
            <el-input v-model="bindingForm.address" maxlength="34" placeholder="输入 T 开头的 TRON 地址" />
            <el-input v-model="bindingForm.label" maxlength="30" placeholder="地址备注（可选）" />
            <el-button
              type="primary"
              :loading="bindingAddress"
              :disabled="accountDisabled || bindings.length >= (config?.maxBoundAddresses || 10)"
              @click="bindAddress"
            >
              添加地址
            </el-button>
          </div>
          <el-alert
            v-else
            title="付款地址绑定当前未开放，但不影响正常充值。"
            type="info"
            :closable="false"
          />
          <div class="table-scroll">
            <el-table :data="bindings" v-loading="bindingsLoading" empty-text="尚未绑定付款地址">
              <el-table-column prop="label" label="备注" min-width="130">
                <template #default="scope">{{ scope.row.label || '未命名地址' }}</template>
              </el-table-column>
              <el-table-column prop="address" label="TRON 地址" min-width="330" />
              <el-table-column prop="boundAt" label="绑定时间" min-width="168">
                <template #default="scope">{{ dateTime(scope.row.boundAt) }}</template>
              </el-table-column>
              <el-table-column label="操作" width="90">
                <template #default="scope">
                  <el-button link type="danger" :disabled="accountDisabled" @click="unbindAddress(scope.row)">解除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <p class="ownership-note">同一付款地址同一时间只能归属一个客户，历史归属按链上区块时间判定。</p>
        </el-tab-pane>

        <el-tab-pane label="异常充值认领" name="claims">
          <div class="tab-toolbar">
            <div>
              <h2>异常充值认领</h2>
              <p>仅用于订单尾数、订单窗口、绑定历史等信息都无法自动归属的真实链上交易。</p>
            </div>
          </div>
          <div class="claim-guidance">
            未绑定付款地址本身不是异常，也不会进入待领；正常订单仍会按精确金额自动匹配并入账。
          </div>
          <div v-if="config?.claimEnabled" class="claim-form">
            <el-select v-model="claimForm.assetCode" aria-label="认领币种">
              <el-option label="USDT-TRC20" value="USDT_TRC20" />
              <el-option label="TRX" value="TRX" />
            </el-select>
            <el-input v-model="claimForm.txid" maxlength="64" placeholder="64 位链上交易哈希 TxID" />
            <el-input v-model="claimForm.rechargeOrderId" maxlength="64" placeholder="关联充值订单号（可选）" />
            <el-button type="primary" :loading="submittingClaim" :disabled="accountDisabled" @click="submitClaim">
              提交核验
            </el-button>
          </div>
          <el-alert v-else title="异常充值认领当前未开放。" type="info" :closable="false" />
          <div class="table-scroll">
            <el-table :data="claims" v-loading="claimsLoading" empty-text="暂无认领记录">
              <el-table-column prop="createdAt" label="提交时间" min-width="168">
                <template #default="scope">{{ dateTime(scope.row.createdAt) }}</template>
              </el-table-column>
              <el-table-column prop="claimId" label="认领单号" min-width="170" />
              <el-table-column label="币种" width="100">
                <template #default="scope">{{ assetSymbol(scope.row.assetCode) }}</template>
              </el-table-column>
              <el-table-column label="交易哈希" min-width="220">
                <template #default="scope">
                  <a :href="transactionUrl(scope.row.txid)" target="_blank" rel="noopener noreferrer">{{ shortHash(scope.row.txid) }}</a>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="130" />
              <el-table-column prop="rejectionReason" label="核验说明" min-width="180">
                <template #default="scope">{{ scope.row.rejectionReason || '-' }}</template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>

    <el-drawer v-model="detailVisible" title="充值订单详情" size="min(520px, 94vw)">
      <div v-if="detailOrder" class="detail-sheet">
        <el-tag :type="statusMeta(detailOrder.status).tag" effect="plain">{{ statusMeta(detailOrder.status).label }}</el-tag>
        <el-descriptions :column="1" border>
          <el-descriptions-item label="订单号">{{ detailOrder.orderId }}</el-descriptions-item>
          <el-descriptions-item label="网络">TRON Mainnet</el-descriptions-item>
          <el-descriptions-item label="币种">{{ assetSymbol(detailOrder.assetCode) }}</el-descriptions-item>
          <el-descriptions-item label="订单金额">{{ amount3(detailOrder.expectedAmount) }}</el-descriptions-item>
          <el-descriptions-item label="链上实到">{{ detailOrder.actualAmount ? amount3(detailOrder.actualAmount) : '-' }}</el-descriptions-item>
          <el-descriptions-item label="到账积分">{{ detailOrder.creditedPoints ? amount3(detailOrder.creditedPoints) : '-' }}</el-descriptions-item>
          <el-descriptions-item v-if="detailOrder.receiveAddress" label="收款地址">{{ detailOrder.receiveAddress }}</el-descriptions-item>
          <el-descriptions-item label="链上交易">
            <a v-if="transactionUrl(detailOrder.txid)" :href="transactionUrl(detailOrder.txid)" target="_blank" rel="noopener noreferrer">
              {{ shortHash(detailOrder.txid || '') }}
            </a>
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ dateTime(detailOrder.createdAt) }}</el-descriptions-item>
          <el-descriptions-item label="到账时间">{{ dateTime(detailOrder.creditedAt) }}</el-descriptions-item>
          <el-descriptions-item v-if="detailOrder.failureMessage" label="处理说明">{{ detailOrder.failureMessage }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-drawer>
  </div>
</template>

<script setup lang="ts">
import { writeClipboardText } from '../utils/clipboard';
import { computed, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRoute } from 'vue-router';
import QrcodeVue from 'qrcode.vue';
import { isUsdtRechargeAsset, safePaymentQrContent } from '../utils/rechargePaymentQr';
import {
  rechargeApi,
  rechargeErrorMessage,
  rechargeErrorRequiresContact,
  type PaymentAddressBinding,
  type RechargeAssetCode,
  type RechargeClaim,
  type RechargeConfig,
  type RechargeOrder
} from '../api/rechargeApi';
import { usePointStore } from '../stores/points';
import { displayDateTime, displayThreeDecimal } from '../utils/formatters';
import { completeRechargeReturn } from '../features/domain-plan/rechargeReturn';
import { hasConsoleSession } from '../api/client';
import {
  assetSymbol,
  canCancelRechargeOrder,
  createRechargeRequestId,
  formatRechargeCountdown,
  isOpenRechargeOrder,
  isValidTronAddress,
  isValidTronTxid,
  normalizeRechargeAmount,
  rechargeStatusMeta,
  tronScanTransactionUrl
} from '../utils/recharge';

const route = useRoute();
const points = usePointStore();
const config = ref<RechargeConfig | null>(null);
const activeOrders = ref<RechargeOrder[]>([]);
const activeOrder = ref<RechargeOrder | null>(null);
const detailOrder = ref<RechargeOrder | null>(null);
const orders = ref<RechargeOrder[]>([]);
const bindings = ref<PaymentAddressBinding[]>([]);
const claims = ref<RechargeClaim[]>([]);
const selectedAsset = ref<RechargeAssetCode>('USDT_TRC20');
const amountInput = ref('');
const activeTab = ref('orders');
const historyAsset = ref('');
const historyStatus = ref('');
const historyPage = ref(1);
const historyPageSize = 20;
const historyTotal = ref(0);
const now = ref(Date.now());
const pageLoading = ref(false);
const pageError = ref('');
const guestMode = computed(() => !hasConsoleSession());
const creatingOrder = ref(false);
const refreshingOrder = ref(false);
const cancellingOrder = ref(false);
const historyLoading = ref(false);
const bindingsLoading = ref(false);
const bindingAddress = ref(false);
const claimsLoading = ref(false);
const submittingClaim = ref(false);
const detailVisible = ref(false);
const bindingForm = reactive({ address: '', label: '' });
const claimForm = reactive({
  assetCode: 'USDT_TRC20' as RechargeAssetCode,
  txid: '',
  rechargeOrderId: ''
});
let clockTimer: number | undefined;
let pollTimer: number | undefined;
let supportDialogShown = false;
let rechargeReturnHandled = false;

const assetOptions = computed(() => config.value?.assets || []);
const selectedAssetOption = computed(() => assetOptions.value.find(item => item.assetCode === selectedAsset.value));
const selectedSymbol = computed(() => assetSymbol(selectedAsset.value));
const accountDisabled = computed(() => config.value?.accountStatus === 'DISABLED');
const actionBlocked = computed(() => guestMode.value || accountDisabled.value || config.value?.rechargeEnabled === false);
const maxActiveOrders = computed(() => config.value?.maxActiveOrders || 5);
const orderLimitReached = computed(() => activeOrders.value.length >= maxActiveOrders.value);
const orderCountdown = computed(() => formatRechargeCountdown(
  activeOrder.value?.expiresAt,
  now.value,
  activeOrder.value?.providerPausedAt
));
const isUsdtOrder = computed(() => isUsdtRechargeAsset(activeOrder.value?.assetCode));
// 2026-09-03: Default to the contract-aware TokenPocket transfer payload so a
// scan can carry the exact amount; retain an address-only compatibility mode.
const usdtQrMode = ref<'amount' | 'address'>('address');
const qrContent = computed(() => safePaymentQrContent(activeOrder.value, usdtQrMode.value));
const paymentInstructionsVisible = computed(() => Boolean(
  activeOrder.value?.paymentWindowOpen
  && activeOrder.value.receiveAddress
  && !activeOrder.value.paymentPaused
  && orderCountdown.value !== '付款窗口已结束'
));
const paymentStatusMessage = computed(() => {
  if (activeOrder.value?.status === 'PAYMENT_DETECTED') return '已经检测到付款，正在等待链上确认';
  if (activeOrder.value?.status === 'CONFIRMING') return '交易正在最终确认，确认后积分自动到账';
  if (activeOrder.value?.status === 'MANUAL_REVIEW') return '订单正在人工复核';
  return '当前付款窗口已经结束';
});
const statusMeta = rechargeStatusMeta;

function amount3(value: unknown) {
  return displayThreeDecimal(value);
}

function dateTime(value: unknown) {
  return value ? displayDateTime(value) : '-';
}

function transactionUrl(txid?: string) {
  return tronScanTransactionUrl(txid);
}

function shortHash(value: string) {
  return value.length > 18 ? `${value.slice(0, 9)}...${value.slice(-7)}` : value;
}

function confirmationText(order: RechargeOrder) {
  if (order.status === 'SUCCESS') return '已完成最终确认';
  if (order.confirmations === undefined || order.requiredConfirmations === undefined) return '等待链上数据';
  return `${order.confirmations} / ${order.requiredConfirmations}`;
}

async function loadConfig() {
  config.value = await rechargeApi.config();
  // 2026-09-03 CST: Provider recovery is automatic. Do not interrupt customers with a
  // technical support modal for a transient scanner pause; operations still receives
  // the provider error and the payment window remains safely paused by the backend.
  const queryAsset = route.query.asset === 'TRX' ? 'TRX' : 'USDT_TRC20';
  const enabled = config.value.assets.find(item => item.assetCode === queryAsset && item.enabled)
    || config.value.assets.find(item => item.enabled);
  if (enabled) selectedAsset.value = enabled.assetCode;
  const queryAmount = typeof route.query.amount === 'string' ? normalizeRechargeAmount(route.query.amount) : null;
  if (queryAmount) amountInput.value = queryAmount;
}

async function loadActiveOrder() {
  const selectedOrderId = activeOrder.value?.orderId;
  activeOrders.value = await rechargeApi.activeOrders();
  activeOrder.value = activeOrders.value.find(order => order.orderId === selectedOrderId)
    || activeOrders.value[0]
    || null;
  if (!activeOrder.value?.paymentPaused) supportDialogShown = false;
}

function selectActiveOrder(order: RechargeOrder) {
  activeOrder.value = order;
}

async function showSupportDialog(message = '链上充值通道暂时繁忙。') {
  if (supportDialogShown) return;
  supportDialogShown = true;
  try {
    await ElMessageBox.alert(
      `${message} 请联系 HotX CDN 客服，并提供客户账号和发生时间，我们会协助核对。`,
      '请联系我们',
      { confirmButtonText: '我知道了', type: 'warning', closeOnClickModal: false }
    );
  } catch {
    // Closing the contact prompt never changes the order or payment state.
  }
}

// 2026-09-03 CST: 精确金额未自动到账时，把用户直接带到认领入口或充值客服，避免无恢复路径。
function openClaimAssistance() {
  activeTab.value = 'claims';
  window.setTimeout(() => {
    document.querySelector<HTMLElement>('.records-surface')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, 0);
}

function showPaymentSupport() {
  // 2026-09-03 CST: 充值求助统一直达平台 TG，减少弹窗中转并与套餐页联系方式保持一致。
  window.open('https://t.me/baichen8888', '_blank', 'noopener,noreferrer');
}

async function loadOrders() {
  historyLoading.value = true;
  try {
    const page = await rechargeApi.orders({
      page: historyPage.value,
      size: historyPageSize,
      assetCode: historyAsset.value || undefined,
      status: historyStatus.value || undefined
    });
    orders.value = page.items || [];
    historyTotal.value = page.total || 0;
  } finally {
    historyLoading.value = false;
  }
}

async function loadBindings() {
  if (!config.value?.addressBindingEnabled) return;
  bindingsLoading.value = true;
  try {
    bindings.value = await rechargeApi.paymentAddresses();
  } finally {
    bindingsLoading.value = false;
  }
}

async function loadClaims() {
  if (!config.value?.claimEnabled) return;
  claimsLoading.value = true;
  try {
    const page = await rechargeApi.claims({ page: 1, size: 20 });
    claims.value = page.items || [];
  } finally {
    claimsLoading.value = false;
  }
}

async function loadPage() {
  if (!hasConsoleSession()) {
    pageLoading.value = false;
    pageError.value = '';
    return;
  }
  pageLoading.value = true;
  pageError.value = '';
  try {
    await loadConfig();
    await Promise.all([loadActiveOrder(), loadOrders(), loadBindings(), loadClaims(), points.refresh()]);
  } catch (error) {
    pageError.value = rechargeErrorMessage(error, '充值中心加载失败，请稍后重试。');
  } finally {
    pageLoading.value = false;
  }
}

async function handleCreateOrder() {
  if (creatingOrder.value || actionBlocked.value || orderLimitReached.value) return;
  const amount = normalizeRechargeAmount(amountInput.value);
  if (!amount) {
    ElMessage.warning('请输入大于 0 且最多三位小数的充值数量。');
    return;
  }
  creatingOrder.value = true;
  try {
    const created = await rechargeApi.createOrder({
      assetCode: selectedAsset.value,
      amount,
      clientRequestId: createRechargeRequestId(),
      linkedConsumptionOrderId: typeof route.query.resumeOrderId === 'string' ? route.query.resumeOrderId : undefined
    });
    activeOrder.value = created;
    ElMessage.success('充值订单已创建，请按精确金额完成转账。');
    // 2026-09-03 CST: The mutation response is authoritative; reconcile lists in the background so the button unlocks immediately.
    void Promise.allSettled([loadActiveOrder(), loadOrders()]);
  } catch (error) {
    ElMessage.error(rechargeErrorMessage(error, '充值订单创建失败，请稍后重试。'));
    if (rechargeErrorRequiresContact(error)) {
      await showSupportDialog(rechargeErrorMessage(error, '充值通道暂时繁忙。'));
    }
  } finally {
    creatingOrder.value = false;
  }
}

async function refreshOrder(silent = false) {
  if (refreshingOrder.value) return;
  refreshingOrder.value = true;
  const previousOrderId = activeOrder.value?.orderId;
  const previousStatus = activeOrder.value?.status;
  try {
    await loadActiveOrder();
    if (previousOrderId && (!activeOrder.value || activeOrder.value.status !== previousStatus)) {
      await Promise.all([loadOrders(), points.refresh()]);
      const latestStatus = activeOrder.value?.orderId === previousOrderId
        ? activeOrder.value.status
        : orders.value.find(order => order.orderId === previousOrderId)?.status;
      if (latestStatus === 'SUCCESS' && !rechargeReturnHandled) {
        rechargeReturnHandled = true;
        // V1.0 / 2026-09-09 CST / parent 15a7174ab: only a confirmed SUCCESS
        // notifies the preserved domain-package window; charging is never retried here.
        void completeRechargeReturn({
          network: 'TRX',
          query: route.query,
          showReturnPrompt: message => ElMessageBox.alert(message, '充值成功', {
            confirmButtonText: '返回原窗口',
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'success'
          }),
          closeRechargeTab: () => window.close()
        });
      }
    }
    if (!silent) ElMessage.success('订单状态已刷新。');
  } catch (error) {
    if (!silent) ElMessage.error(rechargeErrorMessage(error, '订单状态刷新失败，请稍后重试。'));
  } finally {
    refreshingOrder.value = false;
  }
}

async function cancelActiveOrder() {
  if (!activeOrder.value || !canCancelRechargeOrder(activeOrder.value.status)) return;
  try {
    await ElMessageBox.confirm('取消后该订单不再用于正常付款匹配，已经发生的链上转账仍会按实际交易核验。', '确认取消订单', {
      confirmButtonText: '确认取消',
      cancelButtonText: '保留订单',
      type: 'warning'
    });
  } catch {
    return;
  }
  cancellingOrder.value = true;
  try {
    activeOrder.value = await rechargeApi.cancelOrder(activeOrder.value.orderId);
    ElMessage.success('充值订单已取消。');
    // 2026-09-03 CST: The mutation response is authoritative; reconcile lists in the background so the button unlocks immediately.
    void Promise.allSettled([loadActiveOrder(), loadOrders()]);
  } catch (error) {
    ElMessage.error(rechargeErrorMessage(error, '订单取消失败，请稍后重试。'));
    if (rechargeErrorRequiresContact(error)) {
      await showSupportDialog(rechargeErrorMessage(error, '取消前链上查询暂时不可用。'));
    }
  } finally {
    cancellingOrder.value = false;
  }
}

async function bindAddress() {
  const address = bindingForm.address.trim();
  if (!isValidTronAddress(address)) {
    ElMessage.warning('请输入有效的 T 开头 TRON 地址。');
    return;
  }
  bindingAddress.value = true;
  try {
    await rechargeApi.bindPaymentAddress({ address, label: bindingForm.label.trim() || undefined });
    bindingForm.address = '';
    bindingForm.label = '';
    ElMessage.success('付款地址已绑定；不绑定地址也不影响其他充值。');
    await loadBindings();
  } catch (error) {
    ElMessage.error(rechargeErrorMessage(error, '付款地址绑定失败，请稍后重试。'));
  } finally {
    bindingAddress.value = false;
  }
}

async function unbindAddress(binding: PaymentAddressBinding) {
  try {
    await ElMessageBox.confirm(`确认解除付款地址 ${binding.address}？历史归属记录不会被删除。`, '解除付款地址', {
      confirmButtonText: '确认解除',
      cancelButtonText: '取消',
      type: 'warning'
    });
  } catch {
    return;
  }
  try {
    await rechargeApi.unbindPaymentAddress(binding.id);
    ElMessage.success('付款地址已解除。');
    await loadBindings();
  } catch (error) {
    ElMessage.error(rechargeErrorMessage(error, '付款地址解除失败，请稍后重试。'));
  }
}

async function submitClaim() {
  const txid = claimForm.txid.trim();
  if (!isValidTronTxid(txid)) {
    ElMessage.warning('请输入 64 位十六进制链上交易哈希。');
    return;
  }
  submittingClaim.value = true;
  try {
    await rechargeApi.submitClaim({
      assetCode: claimForm.assetCode,
      txid,
      rechargeOrderId: claimForm.rechargeOrderId.trim() || undefined
    });
    claimForm.txid = '';
    claimForm.rechargeOrderId = '';
    ElMessage.success('异常充值认领已提交，系统会自动核验链上交易。');
    await loadClaims();
  } catch (error) {
    ElMessage.error(rechargeErrorMessage(error, '异常充值认领提交失败，请稍后重试。'));
  } finally {
    submittingClaim.value = false;
  }
}

async function openOrderDetail(orderId: string) {
  try {
    detailOrder.value = await rechargeApi.order(orderId);
    detailVisible.value = true;
  } catch (error) {
    ElMessage.error(rechargeErrorMessage(error, '充值订单详情加载失败，请稍后重试。'));
  }
}

async function copyText(value: string, label: string) {
  try { await writeClipboardText(value); ElMessage.success(`${label}已复制。`); }
  catch { ElMessage.error('复制失败，请重试或手动选择内容复制。'); }
}

function resetHistory() {
  historyPage.value = 1;
  loadOrders().catch(error => ElMessage.error(rechargeErrorMessage(error, '充值记录加载失败，请稍后重试。')));
}

onMounted(async () => {
  if (hasConsoleSession()) await loadPage();
  clockTimer = window.setInterval(() => { now.value = Date.now(); }, 1000);
  pollTimer = window.setInterval(() => {
    if (activeOrders.value.length > 0) refreshOrder(true);
  }, 10000);
});

onBeforeUnmount(() => {
  if (clockTimer) window.clearInterval(clockTimer);
  if (pollTimer) window.clearInterval(pollTimer);
});
</script>

<style scoped>
.recharge-page{display:grid;gap:20px;color:#172b42}.recharge-hero{position:relative;overflow:hidden;display:flex;align-items:flex-end;justify-content:space-between;gap:28px;padding:30px;border-radius:18px;color:#f7f9ff;background:linear-gradient(125deg,#081a35 0%,#113967 62%,#0b6f72 100%);box-shadow:0 18px 48px rgba(13,42,78,.2)}.recharge-hero:after{position:absolute;top:-112px;right:-52px;width:262px;height:262px;border:1px solid rgba(255,255,255,.16);border-radius:50%;box-shadow:0 0 0 42px rgba(255,255,255,.035),0 0 0 84px rgba(255,255,255,.025);content:""}.hero-copy-block{position:relative;z-index:1;max-width:680px}.back-link{color:#79dbd0;font-size:13px;font-weight:700;text-decoration:none}.recharge-hero h1{margin:10px 0 8px;font-size:34px;letter-spacing:-.025em}.recharge-hero p{max-width:680px;margin:0;color:#c8d7e8;line-height:1.65}.hero-side{position:relative;z-index:1;display:flex;align-items:flex-end;gap:12px}.bsc-link{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0 16px;border:1px solid rgba(255,255,255,.38);border-radius:10px;color:#fff;background:rgba(7,71,79,.24);font-weight:700;text-decoration:none;white-space:nowrap;transition:background .2s ease,border-color .2s ease,transform .2s ease}.bsc-link:hover{border-color:rgba(255,255,255,.68);background:rgba(7,71,79,.46);transform:translateY(-1px)}.balance-summary{position:relative;z-index:1;display:grid;min-width:210px;gap:4px;padding:18px 20px;border-radius:14px;background:rgba(3,20,39,.38)}.balance-summary span{color:#b9cbdd;font-size:12px}.balance-summary strong{font-size:28px;font-variant-numeric:tabular-nums}.balance-summary a{width:max-content;color:#79dbd0;font-size:12px;text-underline-offset:3px}.recharge-workspace{display:grid;grid-template-columns:minmax(320px,.82fr) minmax(460px,1.18fr);gap:18px;align-items:start}.surface{border:1px solid #e4eaf0;border-radius:16px;background:#fff}.order-builder,.payment-board{min-height:620px;padding:24px}.section-heading,.tab-toolbar{display:flex;align-items:flex-start;justify-content:space-between;gap:18px;margin-bottom:20px}.section-heading h2,.tab-toolbar h2{margin:0 0 6px;font-size:20px;letter-spacing:-.015em}.section-heading p,.tab-toolbar p{max-width:620px;margin:0;color:#738293;font-size:13px;line-height:1.6}.network-chip{padding:6px 9px;border-radius:8px;color:#176b63;background:#e8f7f3;font-size:11px;font-weight:800;white-space:nowrap}.asset-switcher{display:grid;grid-template-columns:1fr 1fr;gap:10px}.asset-option{display:flex;align-items:center;gap:11px;padding:14px;border:1px solid #dfe7ed;border-radius:12px;color:#263b50;background:#f8fafb;text-align:left;cursor:pointer;transition:border-color .2s ease,background .2s ease,transform .2s ease}.asset-option:hover:not(:disabled){border-color:#7fc9be;transform:translateY(-1px)}.asset-option:focus-visible{outline:3px solid rgba(42,138,131,.24);outline-offset:2px}.asset-option.active{border-color:#2a8a83;background:#eaf9f5}.asset-option:disabled{cursor:not-allowed;opacity:.48}.asset-symbol{display:grid;width:44px;height:44px;place-items:center;border-radius:10px;color:#fff;background:#173b5f;font-size:12px;font-weight:900}.asset-option.active .asset-symbol{background:#147a70}.asset-option b,.asset-option small{display:block}.asset-option small{margin-top:4px;color:#778493;font-size:11px}.inline-empty{padding:22px;border-radius:12px;color:#738293;background:#f5f8fa;text-align:center}.rate-strip{display:grid;grid-template-columns:auto 1fr;gap:4px 14px;margin:16px 0;padding:13px 15px;border-radius:12px;background:#f3f7f9}.rate-strip span{color:#748392;font-size:12px}.rate-strip strong{text-align:right;font-variant-numeric:tabular-nums}.rate-strip small{grid-column:1/-1;color:#7e8b98;font-size:11px;text-align:right}.amount-form{margin-top:18px}.field-help,.minimum-hint{margin:-7px 0 10px;color:#607486;font-size:12px;line-height:1.55}.minimum-hint{color:#8a6f3b}.create-button{width:100%;margin-top:8px}.safety-note{display:grid;gap:5px;margin-top:20px;padding-top:18px;border-top:1px solid #e8edf1}.safety-note b{font-size:13px}.safety-note span{color:#718090;font-size:12px;line-height:1.55}.order-state-row{display:flex;align-items:center;justify-content:space-between;gap:14px;margin-bottom:18px}.countdown{color:#68798a;font-size:13px}.countdown b{margin-left:5px;color:#173b5f;font-size:17px;font-variant-numeric:tabular-nums}.order-number{color:#718090;font-size:12px}.payment-core{display:grid;grid-template-columns:208px 1fr;gap:24px;align-items:center;padding:22px;border-radius:14px;background:#f5f8fa}.qr-shell{display:grid;gap:8px;place-items:center;padding:14px;border-radius:12px;background:#fff}.qr-shell small{color:#778493;font-size:11px}.payment-instructions{min-width:0}.instruction-label{display:block;color:#718090;font-size:12px}.exact-amount{display:flex;align-items:baseline;gap:8px;margin:4px 0}.exact-amount strong{color:#123b58;font-size:34px;letter-spacing:-.03em;font-variant-numeric:tabular-nums}.exact-amount b{color:#147a70}.copy-action,.address-line button{padding:0;border:0;color:#177d73;background:transparent;font:inherit;font-size:12px;font-weight:700;cursor:pointer}.copy-action:focus-visible,.address-line button:focus-visible{outline:3px solid rgba(42,138,131,.24);outline-offset:3px}.address-label{margin-top:22px}.address-line{display:flex;align-items:center;gap:9px;margin-top:6px}.address-line code{overflow:hidden;display:block;padding:8px 9px;border-radius:7px;color:#243c52;background:#e8edf1;font-size:12px;text-overflow:ellipsis;white-space:nowrap}.payment-instructions p{margin:10px 0 0;color:#b04e46;font-size:12px}.order-steps{margin:28px 0 24px}.order-facts{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}.order-facts div{display:grid;gap:6px;padding:13px;border-radius:10px;background:#f7f9fa}.order-facts span{color:#758292;font-size:11px}.order-facts b{font-size:13px;font-variant-numeric:tabular-nums}.actual-rule,.ownership-note{margin:14px 0 0;color:#748392;font-size:12px;line-height:1.55}.order-actions{display:flex;align-items:center;justify-content:space-between;margin-top:16px}.order-actions a,.table-scroll a{color:#177d73;font-size:13px;text-underline-offset:3px}.payment-empty{display:grid;min-height:460px;place-items:center;align-content:center;text-align:center}.empty-mark{display:grid;width:88px;height:88px;place-items:center;border-radius:50%;color:#246a69;background:#eaf7f4;font-size:15px;font-weight:900;letter-spacing:.08em}.payment-empty h3{margin:18px 0 7px}.payment-empty p{max-width:390px;margin:0;color:#758292;line-height:1.65}.records-surface{padding:8px 24px 24px}.records-surface :deep(.el-tabs__header){margin-bottom:24px}.records-surface :deep(.el-tabs__item){height:52px;font-weight:700}.tab-toolbar>span{color:#627486;font-size:13px}.filters{display:flex;gap:10px}.filters :deep(.el-select){width:138px}.table-scroll{overflow-x:auto}.table-scroll :deep(.el-table){min-width:760px}.records-surface :deep(.el-pagination){justify-content:flex-end;margin-top:18px}.address-form{display:grid;grid-template-columns:minmax(280px,1.4fr) minmax(180px,.8fr) auto;gap:10px;margin-bottom:18px}.claim-guidance{margin-bottom:16px;padding:13px 15px;border-radius:10px;color:#365b68;background:#edf7f5;font-size:13px;line-height:1.55}.claim-form{display:grid;grid-template-columns:150px minmax(300px,1.4fr) minmax(220px,.8fr) auto;gap:10px;margin-bottom:18px}.detail-sheet{display:grid;gap:18px}.detail-sheet>.el-tag{width:max-content}.detail-sheet a{color:#177d73}.recharge-page :deep(.el-input__inner),.recharge-page :deep(.el-table){font-variant-numeric:tabular-nums}.recharge-page :deep(.el-button:focus-visible){outline:3px solid rgba(42,138,131,.24);outline-offset:2px}@media(max-width:1100px){.recharge-workspace{grid-template-columns:1fr}.order-builder,.payment-board{min-height:auto}.claim-form{grid-template-columns:150px 1fr}.claim-form .el-button{grid-column:2}.address-form{grid-template-columns:1fr 1fr}.address-form .el-button{grid-column:2}}@media(max-width:720px){.recharge-page{gap:14px}.recharge-hero{align-items:flex-start;flex-direction:column;padding:22px}.recharge-hero h1{font-size:29px}.hero-side{width:100%;align-items:stretch;flex-direction:column}.bsc-link{width:max-content}.balance-summary{width:100%;box-sizing:border-box}.order-builder,.payment-board{padding:18px}.payment-core{grid-template-columns:1fr;padding:16px}.exact-amount strong{font-size:29px}.order-facts{grid-template-columns:1fr}.section-heading,.tab-toolbar{align-items:flex-start;flex-direction:column}.filters{width:100%}.filters :deep(.el-select){width:50%}.records-surface{padding:4px 16px 18px}.address-form,.claim-form{grid-template-columns:1fr}.address-form .el-button,.claim-form .el-button{grid-column:auto}.asset-switcher{grid-template-columns:1fr}.order-actions{align-items:flex-start;flex-direction:column;gap:10px}}@media(max-width:430px){.filters{flex-direction:column}.filters :deep(.el-select){width:100%}.qr-shell{padding:10px}.address-line{align-items:flex-start;flex-direction:column}.address-line code{width:100%;box-sizing:border-box}.order-state-row{align-items:flex-start;flex-direction:column}}
.active-order-limit{margin:9px 0 0;color:#718090;font-size:12px;text-align:center}.active-order-switcher{display:flex;gap:8px;margin-bottom:14px;overflow-x:auto}.active-order-switcher button{flex:0 0 auto;padding:7px 10px;border:1px solid #dce5ea;border-radius:9px;color:#526779;background:#f7fafb;cursor:pointer}.active-order-switcher button.active{border-color:#2a8a83;color:#126d65;background:#eaf9f5}.provider-paused-alert{margin-bottom:16px}.payment-status-only{display:grid;gap:7px;padding:28px;border-radius:14px;color:#526779;background:#f5f8fa;text-align:center}.payment-status-only b{color:#173b5f}

/* 2026-09-03 CST：付款区改为稳定双栏，短地址码独立留白，避免二维码与金额、警告互相覆盖。 */
.recharge-workspace{grid-template-columns:minmax(300px,.68fr) minmax(680px,1.32fr)}
.payment-core{grid-template-columns:minmax(296px,320px) minmax(0,1fr);gap:28px;align-items:start;padding:24px;background:#f3f7f7}
.qr-shell{align-self:stretch;box-sizing:border-box;gap:10px;padding:16px;border:1px solid #e3eae8;box-shadow:0 10px 28px rgba(20,72,67,.07)}
.qr-step{padding:5px 9px;border-radius:7px;color:#176b63;background:#e8f7f3;font-size:11px;font-weight:800;letter-spacing:.02em}
.qr-frame{display:grid;width:100%;min-height:292px;box-sizing:border-box;place-items:center;padding:12px;border:1px solid #edf1ef;border-radius:10px;background:#fff}
.qr-frame :deep(svg){display:block;max-width:100%;height:auto;shape-rendering:crispEdges}
.qr-shell>strong{color:#18364d;font-size:15px;text-align:center}
.qr-shell>small{color:#607486;font-size:12px;font-weight:600;text-align:center}
.payment-instructions{display:grid;min-width:0;gap:18px}
.amount-block{padding:18px;border:1px solid #dbe9e6;border-radius:12px;background:#fff}
.exact-amount{margin:6px 0 4px}
.payment-flow{display:grid;gap:9px;margin:0;padding:0;list-style:none}
.payment-flow li{display:grid;grid-template-columns:28px minmax(0,1fr);gap:10px;align-items:center;padding:10px 12px;border-radius:10px;background:#e9f2f0}
.payment-flow li>span{display:grid;width:28px;height:28px;place-items:center;border-radius:8px;color:#fff;background:#177d73;font-size:12px;font-weight:800}
.payment-flow b,.payment-flow small{display:block}
.payment-flow b{color:#213d4e;font-size:13px}
.payment-flow small{margin-top:2px;color:#70808c;font-size:11px}
.address-block{min-width:0;padding-top:2px}
.address-label{margin-top:0}
.address-line{min-width:0}
.address-line code{flex:1;min-width:0;padding:10px 11px;background:#e6ecec;font-size:13px}
@media(max-width:1280px){.recharge-workspace{grid-template-columns:minmax(0,1fr);min-width:0}.recharge-workspace>*{min-width:0}.order-builder,.payment-board{min-height:auto}}
@media(max-width:720px){.recharge-page{grid-template-columns:minmax(0,1fr);min-width:0}.payment-core{grid-template-columns:minmax(0,1fr);width:100%;min-width:0;gap:18px;padding:14px}.qr-shell,.qr-frame,.payment-instructions{width:auto;min-width:0;max-width:100%}.qr-shell{padding:14px}.qr-frame{min-height:auto;padding:10px}.exact-amount strong{font-size:31px}}
@media(max-width:430px){.qr-frame :deep(svg){width:238px;height:238px}.payment-flow li{padding:9px}}
/* 2026-09-03: Quiet two-mode control; payment details stay primary. */
.qr-mode-switch{
  display:grid;
  grid-template-columns:1fr 1fr;
  width:min(100%,268px);
  margin:8px auto 12px;
  padding:4px;
  border:1px solid #dce8e3;
  border-radius:12px;
  background:#edf5f2
}
.qr-mode-button{
  min-height:34px;
  padding:7px 10px;
  border:0;
  border-radius:9px;
  background:transparent;
  color:#5f746d;
  font:inherit;
  font-size:13px;
  font-weight:700;
  cursor:pointer
}
.qr-mode-button.active{
  background:#fff;
  color:#087a70;
  box-shadow:0 3px 12px rgba(16,86,77,.12)
}

/* 2026-09-03: PC 付款核对区固定为金额、地址、操作步骤，避免用户上下往返核对。 */
.qr-mode-switch {
  display: none;
}

.payment-instructions {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.amount-block {
  order: 1;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.address-block {
  order: 2;
  margin-top: -1px;
  padding: 14px 18px 16px;
  background: #ffffff;
  border: 1px solid #d8e5e1;
  border-top: 1px dashed #bfd2cc;
  border-radius: 0 0 14px 14px;
}

.payment-flow {
  order: 4;
  margin-top: 16px;
}

/* 2026-09-03 CST: F 方案只强调精确金额后三位，整数保持稳定，避免动画影响金额核对。 */
.exact-amount {
  /* 2026-09-03 CST: 为尾数说明预留独立高度，禁止与复制金额操作发生覆盖。 */
  margin-bottom: 22px;
}

.payment-amount-tail-focus {
  display: inline-flex;
  align-items: baseline;
  letter-spacing: -0.03em;
}

.payment-amount-major {
  color: #123b58;
}

.payment-amount-tail {
  position: relative;
  display: inline-flex;
  align-items: baseline;
  margin-left: 2px;
  padding: 0 4px 2px;
  border: 1px solid #e6cf91;
  border-radius: 8px;
  background: #fff9e8;
  letter-spacing: 0;
  line-height: 0.98;
  transform-origin: 50% 60%;
  animation: recharge-tail-frame 3.4s cubic-bezier(0.16, 1, 0.3, 1) infinite;
}

.payment-amount-tail-digit {
  display: inline-block;
  min-width: 0.57em;
  color: #123b58;
  text-align: center;
  transform-origin: 50% 100%;
  animation: recharge-tail-digit 3.4s cubic-bezier(0.16, 1, 0.3, 1) infinite;
}

.payment-amount-tail-digit-2 {
  animation-delay: 95ms;
}

.payment-amount-tail-digit-3 {
  animation-delay: 190ms;
}

.payment-tail-caption {
  position: absolute;
  top: calc(100% + 5px);
  left: 50%;
  color: #8a5b08;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1;
  transform: translateX(-50%);
  white-space: nowrap;
}

@keyframes recharge-tail-frame {
  0%,
  7%,
  42%,
  100% {
    border-color: #e6cf91;
    background: #fff9e8;
    box-shadow: 0 0 0 rgba(192, 135, 34, 0);
    transform: scale(0.98);
  }

  13%,
  32% {
    border-color: #d2a13d;
    background: #fff1c9;
    box-shadow: 0 8px 18px rgba(192, 135, 34, 0.2);
    transform: scale(1.05);
  }

  22% {
    transform: scale(1);
  }
}

@keyframes recharge-tail-digit {
  0%,
  7%,
  38%,
  100% {
    color: #123b58;
    transform: translateY(0) scale(1);
  }

  14% {
    color: #a96808;
    transform: translateY(-6px) scale(1.13);
  }

  22% {
    color: #0d756d;
    transform: translateY(1px) scale(0.99);
  }

  30% {
    color: #123b58;
    transform: translateY(-2px) scale(1.035);
  }
}

.exact-match-notice {
  order: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding: 13px 15px;
  border: 1px solid #e9d6a3;
  border-radius: 12px;
  background: #fff9e9;
  color: #6c5114;
}

.exact-match-copy {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.exact-match-copy strong {
  color: #513b0b;
  font-size: 13px;
  line-height: 1.45;
}

.exact-match-copy span {
  font-size: 12px;
  line-height: 1.55;
}

/* 2026-09-03 CST: E3 方案依次点亮到账风险词，再把视线引向认领和客服恢复入口。 */
.exact-match-risk-word {
  display: inline-block;
  color: #6c5114;
  transform-origin: 50% 60%;
  animation: exact-match-risk-pulse 5s cubic-bezier(0.16, 1, 0.3, 1) infinite;
}

.exact-match-risk-word-2 {
  animation-delay: 180ms;
}

.exact-match-risk-word-3 {
  animation-delay: 360ms;
}

.recovery-flow {
  position: relative;
  flex: 1 1 72px;
  min-width: 44px;
  max-width: 88px;
  height: 18px;
  opacity: 0.18;
  animation: recovery-flow-visibility 5s ease infinite;
}

.recovery-flow::before {
  position: absolute;
  top: 8px;
  right: 7px;
  left: 0;
  height: 2px;
  background: repeating-linear-gradient(90deg, #17877c 0 7px, transparent 7px 14px);
  background-size: 14px 2px;
  content: "";
  animation: recovery-flow-route 700ms linear infinite;
}

.recovery-flow::after {
  position: absolute;
  top: 5px;
  right: 1px;
  width: 7px;
  height: 7px;
  border-top: 2px solid #17877c;
  border-right: 2px solid #17877c;
  content: "";
  transform: rotate(45deg);
}

@keyframes exact-match-risk-pulse {
  0%,
  8%,
  32%,
  100% {
    color: #6c5114;
    transform: translateY(0) scale(1);
  }

  14% {
    color: #b14d31;
    transform: translateY(-3px) scale(1.12);
  }

  23% {
    color: #a46808;
    transform: translateY(0) scale(1);
  }
}

@keyframes recovery-flow-visibility {
  0%,
  34%,
  82%,
  100% {
    opacity: 0.18;
  }

  43%,
  72% {
    opacity: 1;
  }
}

@keyframes recovery-flow-route {
  to {
    background-position: 14px 0;
  }
}

.exact-match-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}

.exact-match-actions button {
  min-height: 32px;
  padding: 0 11px;
  border: 1px solid #d8bd78;
  border-radius: 8px;
  background: #fffdf7;
  color: #6a4b05;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}

.exact-match-actions button:first-child {
  transform-origin: 50% 50%;
  animation: recovery-claim-pulse 5s ease infinite;
}

.exact-match-actions button:last-child {
  transform-origin: 50% 50%;
  animation: recovery-contact-pulse 5s ease infinite;
}

@keyframes recovery-claim-pulse {
  0%,
  50%,
  76%,
  100% {
    border-color: #d8bd78;
    background: #fffdf7;
    box-shadow: 0 0 0 rgba(23, 135, 124, 0);
    transform: scale(1);
  }

  58%,
  68% {
    border-color: #278e84;
    background: #edf9f6;
    box-shadow: 0 6px 14px rgba(23, 135, 124, 0.2);
    transform: scale(1.055);
  }
}

@keyframes recovery-contact-pulse {
  0%,
  68%,
  92%,
  100% {
    box-shadow: 0 0 0 rgba(192, 135, 34, 0);
    transform: scale(1);
  }

  76%,
  85% {
    box-shadow: 0 5px 12px rgba(192, 135, 34, 0.17);
    transform: scale(1.035);
  }
}

.exact-match-actions button:hover {
  border-color: #af8934;
  background: #fff4d4;
  color: #493300;
}

.exact-match-actions button:focus-visible {
  outline: 3px solid rgba(24, 143, 132, 0.24);
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  .payment-amount-tail,
  .payment-amount-tail-digit,
  .exact-match-risk-word,
  .recovery-flow,
  .recovery-flow::before,
  .exact-match-actions button:first-child,
  .exact-match-actions button:last-child {
    animation: none;
  }

  .payment-amount-tail {
    border-color: #d2a13d;
    background: #fff1c9;
    transform: none;
  }

  .payment-amount-tail-digit,
  .exact-match-risk-word {
    color: #a46808;
  }

  .recovery-flow {
    opacity: 1;
  }

  .exact-match-actions button {
    transition: none;
  }
}

@media (max-width: 720px) {
  .exact-match-notice {
    align-items: flex-start;
    flex-direction: column;
  }

  .recovery-flow {
    display: none;
  }

  .exact-match-actions {
    width: 100%;
  }
}


/* 2026-09-03 CST: 充值主操作按金额状态分层；空值安静、有效金额使用 HotX 绿黄高光与柔和纵深。 */
.create-button {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border: 1px solid #aebdb4 !important;
  background: linear-gradient(145deg, #e1e8e3 0%, #ced9d2 54%, #bdc9c1 100%) !important;
  color: #68786e !important;
  box-shadow:
    0 2px 0 #9eaea4,
    0 5px 12px rgba(29, 71, 51, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.82) !important;
  filter: saturate(0.45);
  text-shadow: none;
  transform: translateY(0);
  transition:
    transform 180ms cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 180ms ease,
    filter 180ms ease,
    color 180ms ease;
}

.create-button::before {
  position: absolute;
  z-index: -1;
  inset: 0;
  background: linear-gradient(112deg, transparent 18%, rgba(255, 244, 170, 0.42) 48%, transparent 72%);
  content: '';
  opacity: 0;
  pointer-events: none;
  transform: translateX(-78%);
  transition: opacity 180ms ease;
}

.create-button[data-amount-ready="true"]:not(.is-disabled) {
  border-color: #167252 !important;
  background: linear-gradient(135deg, #0b7553 0%, #12a16a 46%, #79b84b 73%, #d8b33f 100%) !important;
  color: #ffffff !important;
  box-shadow:
    0 4px 0 #09563e,
    0 10px 20px rgba(12, 111, 76, 0.24),
    inset 0 1px 0 rgba(255, 249, 201, 0.54) !important;
  filter: saturate(1.08);
  text-shadow: 0 1px 1px rgba(3, 58, 40, 0.35);
  transform: translateY(-2px);
}

.create-button[data-amount-ready="true"]:not(.is-disabled)::before {
  opacity: 1;
  transform: translateX(78%);
  transition:
    opacity 180ms ease,
    transform 720ms cubic-bezier(0.22, 1, 0.36, 1);
}

.create-button[data-amount-ready="true"]:not(.is-disabled):hover {
  box-shadow:
    0 5px 0 #09563e,
    0 13px 24px rgba(12, 111, 76, 0.28),
    inset 0 1px 0 rgba(255, 249, 201, 0.62) !important;
  filter: brightness(1.04) saturate(1.12);
  transform: translateY(-3px);
}

.create-button[data-amount-ready="true"]:not(.is-disabled):active {
  box-shadow:
    0 1px 0 #09563e,
    0 4px 10px rgba(12, 111, 76, 0.2),
    inset 0 1px 3px rgba(3, 58, 40, 0.18) !important;
  transform: translateY(1px);
}

.create-button:focus-visible {
  outline: 3px solid rgba(217, 181, 62, 0.4);
  outline-offset: 3px;
}

.create-button.is-disabled,
.create-button.is-loading {
  cursor: not-allowed;
  filter: grayscale(0.12) saturate(0.3);
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  .create-button,
  .create-button::before {
    transition: none;
  }
}



/* 2026-09-03 CST: Empty-state guidance uses the product green/gold palette and never competes with active input. */
:deep(.recharge-amount-input.is-empty-guided:not(.is-disabled):not(:focus-within)) {
  border-radius: 8px;
  animation: recharge-amount-guide 2.25s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  will-change: box-shadow, transform;
}

@keyframes recharge-amount-guide {
  0%, 100% {
    box-shadow: 0 0 0 1px rgba(13, 139, 106, 0.18), 0 0 0 0 rgba(220, 178, 43, 0);
    transform: scale(1);
  }
  45% {
    box-shadow: 0 0 0 2px rgba(13, 139, 106, 0.72), 0 0 0 8px rgba(220, 178, 43, 0.2), 0 8px 22px rgba(13, 139, 106, 0.16);
    transform: scale(1.012);
  }
  62% {
    box-shadow: 0 0 0 2px rgba(220, 178, 43, 0.68), 0 0 0 13px rgba(13, 139, 106, 0.08), 0 8px 22px rgba(13, 139, 106, 0.12);
    transform: scale(1.006);
  }
}

@media (prefers-reduced-motion: reduce) {
  :deep(.recharge-amount-input.is-empty-guided:not(.is-disabled)) {
    animation: none;
    box-shadow: 0 0 0 2px rgba(13, 139, 106, 0.55), 0 0 0 6px rgba(220, 178, 43, 0.14);
  }
}

/* 2026-09-03 CST: Match the compact dark-green 3D action language selected by the product owner. */
:deep(.create-button[data-amount-ready='true']:not(.is-disabled)) {
  --el-button-bg-color: #0b6b3a;
  --el-button-border-color: #07542d;
  --el-button-text-color: #ffffff;
  --el-button-hover-bg-color: #0d7540;
  --el-button-hover-border-color: #07542d;
  --el-button-active-bg-color: #07572f;
  --el-button-active-border-color: #064526;
  background: linear-gradient(180deg, #138049 0%, #0b6b3a 54%, #07572f 100%);
  border-color: #07542d;
  color: #ffffff;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 4px 0 #064526,
    0 8px 16px rgba(5, 70, 37, 0.2);
  text-shadow: 0 1px 1px rgba(0, 40, 20, 0.32);
  transform: translateY(-1px);
}

:deep(.create-button[data-amount-ready='true']:not(.is-disabled):hover) {
  background: linear-gradient(180deg, #16894f 0%, #0d7540 56%, #086235 100%);
  border-color: #07542d;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.24),
    0 5px 0 #064526,
    0 10px 20px rgba(5, 70, 37, 0.24);
  transform: translateY(-2px);
}

:deep(.create-button[data-amount-ready='true']:not(.is-disabled):active) {
  background: linear-gradient(180deg, #096536 0%, #07572f 100%);
  box-shadow:
    inset 0 1px 2px rgba(0, 35, 18, 0.2),
    0 1px 0 #064526,
    0 3px 8px rgba(5, 70, 37, 0.18);
  transform: translateY(2px);
}
</style>

<style scoped>
/* 2026-09-03: 充值主按钮采用已确认的 F2 缎面松绿方案；仅金额有效且操作可用时高亮。 */
.create-button[data-amount-ready='true']:not(.is-disabled) {
  color: #fff !important;
  border: 1px solid #064a35 !important;
  background:
    radial-gradient(ellipse at 50% 34%, rgba(38, 145, 106, 0.34) 0%, rgba(38, 145, 106, 0) 68%),
    linear-gradient(180deg, #147556 0%, #0b6447 58%, #07543c 100%) !important;
  box-shadow:
    inset 0 1px 0 rgba(222, 255, 242, 0.18),
    0 5px 10px rgba(21, 62, 50, 0.18),
    0 1px 2px rgba(5, 55, 39, 0.2) !important;
  text-shadow: 0 1px 1px rgba(3, 44, 31, 0.24);
  transform: translateY(0);
  transition: background 180ms ease, border-color 180ms ease, box-shadow 180ms ease, transform 120ms ease;
}

.create-button[data-amount-ready='true']:not(.is-disabled):hover,
.create-button[data-amount-ready='true']:not(.is-disabled):focus-visible {
  border-color: #07583f !important;
  background:
    radial-gradient(ellipse at 50% 32%, rgba(48, 158, 117, 0.38) 0%, rgba(48, 158, 117, 0) 68%),
    linear-gradient(180deg, #187c5b 0%, #0d6b4c 58%, #085940 100%) !important;
  box-shadow:
    inset 0 1px 0 rgba(230, 255, 246, 0.22),
    0 7px 14px rgba(21, 62, 50, 0.2),
    0 1px 2px rgba(5, 55, 39, 0.22) !important;
  transform: translateY(-1px);
}

.create-button[data-amount-ready='true']:not(.is-disabled):active {
  transform: translateY(1px);
  box-shadow:
    inset 0 2px 4px rgba(3, 47, 33, 0.18),
    0 2px 5px rgba(21, 62, 50, 0.16) !important;
}

.create-button[data-amount-ready='false'],
.create-button.is-disabled {
  color: #8d9994 !important;
  border-color: #cbd4d0 !important;
  background: linear-gradient(180deg, #e7ebe9 0%, #dce2df 100%) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.72), 0 1px 2px rgba(41, 58, 51, 0.08) !important;
  text-shadow: none;
  transform: none;
}
</style>
